<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Marketing Staff",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Marketing Staff",
            items: [
               {
                  text: "Marketing Staffs",
                  href: "/marketing-staffs",
               },
               {
                  text: "Edit Marketing Staff",
                  active: true,
               },        
            ],

            staff: {
               id: null,
               name: 'Alan Joe',
               mobile: '9110011222',
               email: 'alanjoe@xyz.com',
               address: '',
               whatsapp: '9110011222',
               image: 1,
               
            },

         };
      },
      mounted() {
    
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'marketingstaffs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form">
                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Name <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="staff.name"/>
                           </div>                     
                           
                           <div class="form-group col-md-6">
                              <label>Mobile No. <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="staff.mobile"/>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Email ID</label>
                              <input type="email" class="form-control" v-model="staff.email"/>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Whatsapp No. <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="staff.whatsapp"/>
                           </div>
                           
                           <div class="form-group col-md-12">
                              <label>Address</label>
                              <textarea rows="2" class="form-control" v-model="staff.address"></textarea>
                           </div>   

                           <div class="form-group col-md-6">
                              <label>ID Proof Image <span class="text-danger">*</span></label><br>
                              <a href="#" target="_blank"><img src="@/assets/images/users/avatar-3.jpg" alt="ID Proof" class="avatar-md mb-2"></a>

                              <input type="file" class="form-control" name="">
                              <p class="small">(Leave this field empty if you don't want to change the image)</p>
                           </div>                                                                           
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'marketingstaffs' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
